import { useModal } from "@/features/modal/ModalStackManager";
import { FormButtonBox } from "@/features/standard/form/FormButtonBox";
import { FormMain } from "@/features/standard/form/FormMain";
import { FormWrapper } from "@/features/standard/form/FormWrapper";
import customAlert from "@/features/ui/alert/Alert";
import { validateFormValues } from "@/utils/validation";
import { Button, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";

const Update = Object.assign(FormMain, {
  Button: Button,
  Input: TextInput,
  Wrapper: FormWrapper,
  ButtonBox: FormButtonBox,
});

export const ErrorViewUpdateForm = (params: any) => {
  const { formatterProps } = params;
  const { closeModal } = useModal();

  const form = useForm({
    initialValues: {
      machineCode: formatterProps.machineCode ?? undefined,
      machineName: formatterProps.machineName ?? undefined,
      createdAt: formatterProps.createdAt ?? undefined,
    },
  });

  const onSubmit = async () => {
    try {
      customAlert("기계 정보 수정에 실패하였습니다.", "수정 실패", "red");
    } catch (e) {
      customAlert("기계 정보 수정에 실패하였습니다.", "수정 실패", "red");
    }
  };

  return (
    <Update.Wrapper>
      <Update.Input label="기계제조사" withAsterisk {...form.getInputProps("machineCode")} />
      <Update.Input label="기계이름" withAsterisk {...form.getInputProps("machineName")} />
      <Update.ButtonBox>
        <Update.Button color="gray" onClick={closeModal}>
          취소
        </Update.Button>
        <Update.Button
          onClick={onSubmit}
          disabled={validateFormValues({
            pageType: "errorMachine",
            values: form.values,
          })}
        >
          기계 정보 수정
        </Update.Button>
      </Update.ButtonBox>
    </Update.Wrapper>
  );
};
